<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-hospital`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M45.993 1.883A1 1 0 0045 1H17l-.117.007A1 1 0 0016 2v20.5H3l-.117.007A1 1 0 002 23.5V46l.007.117A1 1 0 003 47h42l.117-.007A1 1 0 0046 46V2l-.007-.117zM20 5h22v38h-8v-9.281a1 1 0 00-1-1h-4a1 1 0 00-1 1V43h-8V5zm-4 21.5H6V43h10V26.5zM33 10a1 1 0 00-1-1h-2a1 1 0 00-1 1v3h-3a1 1 0 00-1 1v2a1 1 0 001 1h3v3a1 1 0 001 1h2a1 1 0 001-1v-3h3a1 1 0 001-1v-2a1 1 0 00-1-1h-3v-3z"/></svg>
</template>
<script>

export default {
  name: 'IconHospital',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
